module.exports = __webpack_public_path__ + "img/dj1.3daa9e82.svg";